export enum OnboardingRequestHeaderAttributes {
  X_PIN_CODE = 'X-PIN-CODE',
}
